import { Flex, Heading, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

const BoxHeader = ({
  title,
  rightAddon,
  mb = "16px",
  fontWeight = "600",
}: {
  title: string;
  rightAddon?: ReactNode;
  mb?: string;
  fontWeight?: string;
}) => {
  return (
    <Flex justifyContent="space-between">
      <Heading
        fontSize="20px"
        fontWeight={fontWeight}
        mb={mb}
        whiteSpace="nowrap"
      >
        {title}
      </Heading>
      {rightAddon}
    </Flex>
  );
};

export default BoxHeader;
